var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustwallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60077",
    "data-name": "Group 60077",
    transform: "translate(-1699 -3608)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1529",
    "data-name": "Ellipse 1529",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1704 3612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60077-2",
    "data-name": "Group 60077",
    transform: "translate(-893 -1590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16353",
    "data-name": "Rectangle 16353",
    width: 32,
    height: 32,
    transform: "translate(2592 5198)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(2593 5198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17652",
    "data-name": "Path 17652",
    d: "M.089,5.456C-1,7.6-1,10.4-1,16S-1,24.4.089,26.542a10.073,10.073,0,0,0,4.368,4.368C6.6,32,9.4,32,15,32s8.4,0,10.543-1.089a10.073,10.073,0,0,0,4.368-4.368C31,24.4,31,21.6,31,16s0-8.4-1.089-10.543a10.073,10.073,0,0,0-4.368-4.368C23.4,0,20.6,0,15,0S6.6,0,4.456,1.089A10.053,10.053,0,0,0,.089,5.456ZM23.005,8.633a1.056,1.056,0,0,1,.742.307,1.034,1.034,0,0,1,.294.742c-.051,2.985-.166,5.264-.384,7.07a14.506,14.506,0,0,1-1,4.228,6.513,6.513,0,0,1-1.179,1.832,9.025,9.025,0,0,1-2.126,1.627c-.333.2-.678.4-1.051.6-.781.435-1.627.923-2.6,1.576a1.048,1.048,0,0,1-1.153,0c-.987-.653-1.844-1.14-2.626-1.588-.179-.1-.346-.192-.512-.294a11.041,11.041,0,0,1-2.46-1.768A6.215,6.215,0,0,1,7.72,21.2a12.738,12.738,0,0,1-.987-3.51,61.966,61.966,0,0,1-.5-8.032,1.067,1.067,0,0,1,.294-.742,1.056,1.056,0,0,1,.742-.307h.435a10.95,10.95,0,0,0,6.789-2.1,1.04,1.04,0,0,1,1.281,0,10.952,10.952,0,0,0,6.789,2.1H23v.026Zm-2.331,11.7a10.57,10.57,0,0,0,.808-2.934,54.079,54.079,0,0,0,.461-6.7,12.871,12.871,0,0,1-6.8-2.062A12.867,12.867,0,0,1,8.353,10.7c.051,2.434.166,4.33.346,5.816a12.943,12.943,0,0,0,.846,3.638,4.226,4.226,0,0,0,.808,1.256A6.632,6.632,0,0,0,12,22.661c.294.179.627.358.987.563.64.358,1.358.768,2.177,1.281.794-.512,1.512-.91,2.139-1.268q.288-.154.538-.307a8.479,8.479,0,0,0,2.011-1.422,4.559,4.559,0,0,0,.833-1.2Z",
    fill: "#3375bb",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustwallet);
export default __webpack_public_path__ + "static/media/trustwallet.b4effac2e42e1bf0139d0e4d6af7bbce.svg";
export { ForwardRef as ReactComponent };